import * as React from 'react';
import { safeHref } from '../../helper';

/**
 * Cell with link component.
 * @param {Object} params
 * @returns {JSX.Element}
 */
export default function (params) {
  const {value, column, row, fields} = params;

  const href = row && row[column] && row[`${column}_url`] ? safeHref(row[`${column}_url`]) : null;
  if (href) {
    let attributeProps = {};
    if (fields && fields[column]) {
      attributeProps = fields[column]['attributes'].reduce((acc, attr) => {
        acc[attr.key] = attr.value;
        return acc;
      }, {});
    }

    return (
      <div className='cell cell--url'>
        <a href={href} {...attributeProps}>
          {value}
        </a>
      </div>
    );
  }

  return (
    <div className='cell cell--url'>
      {value}
    </div>
  );
}
